import { createEndpoints } from '../../_helpers/utile/endpoint.helper';

export const STATISTICS_ENDPOINTS = {
  V1: createEndpoints('v1', {
    STATISTICS: '/admin/statistics',
  }),
} as const;
